// @flow
import React, { Component } from 'react';
import { Form } from 'informed';
import moment from 'moment';

import { PrimaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';
import DatetimeText from '../../../DatetimeText.jsx';

import ViewCardiovascular from './ViewCardiovascular.jsx';
import ViewRespiratory from './ViewRespiratory.jsx';
import ViewNeurological from './ViewNeurological.jsx';
import ViewIntegumentary from './ViewIntegumentary.jsx';
import ViewSensory from './ViewSensory.jsx';
import ViewMusculoskeletal from './ViewMusculoskeletal.jsx';
import ViewGastrointestinal from './ViewGastrointestinal.jsx';
import ViewGenitourinary from './ViewGenitourinary.jsx';
import ViewPain from './ViewPain.jsx';
import ViewPsychosocial from './ViewPsychosocial.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  note: Object,
  closePage: Function,
}

type State = {
  selectedSystem: string,
}

class ViewSystemAssessment extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedSystem: 'cardiovascular',
    };
  }

  componentDidMount() {
    if (!Object.keys(this.props.note).length) {
      this.props.closePage();
    }
  }

  handleSystemSelect = (event: Object) => {
    const system = event.target.getAttribute('value');
    this.setState(prevState => ({
      ...prevState,
      selectedSystem: system,
    }));
  }

  render() {
    const data = this.props.note;
    const {
      cardiovascular,
      respiratory,
      neurological,
      integumentary,
      sensory,
      musculoskeletal,
      gastrointestinal,
      genitourinary,
      pain,
      psychosocial,
      editors,
      editDates,
    } = data;

    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    const { selectedSystem } = this.state;
    const systemSelector = (
      <ContentBox>
        <table className={styles.systemSelector}>
          <tbody>
            <tr>
              <td onClick={this.handleSystemSelect} value='cardiovascular' className={`${styles.systemButton} ${selectedSystem === 'cardiovascular' ? styles.active : ''}`}>Cardiovascular</td>
              <td onClick={this.handleSystemSelect} value='respiratory' className={`${styles.systemButton} ${selectedSystem === 'respiratory' ? styles.active : ''}`}>Respiratory</td>
              <td onClick={this.handleSystemSelect} value='neurological' className={`${styles.systemButton} ${selectedSystem === 'neurological' ? styles.active : ''}`}>Neurological</td>
              <td onClick={this.handleSystemSelect} value='integumentary' className={`${styles.systemButton} ${selectedSystem === 'integumentary' ? styles.active : ''}`}>Integumentary</td>
              <td onClick={this.handleSystemSelect} value='sensory' className={`${styles.systemButton} ${selectedSystem === 'sensory' ? styles.active : ''}`}>Sensory</td>
            </tr>
            <tr>
              <td><div onClick={this.handleSystemSelect} value='musculoskeletal' className={`${styles.systemButton} ${selectedSystem === 'musculoskeletal' ? styles.active : ''}`}>Musculoskeletal</div></td>
              <td><div onClick={this.handleSystemSelect} value='gastrointestinal' className={`${styles.systemButton} ${selectedSystem === 'gastrointestinal' ? styles.active : ''}`}>Gastrointestinal</div></td>
              <td><div onClick={this.handleSystemSelect} value='genitourinary' className={`${styles.systemButton} ${selectedSystem === 'genitourinary' ? styles.active : ''}`}>Genitourinary</div></td>
              <td><div onClick={this.handleSystemSelect} value='pain' className={`${styles.systemButton} ${selectedSystem === 'pain' ? styles.active : ''}`}>Pain</div></td>
              <td><div onClick={this.handleSystemSelect} value='psychosocial' className={`${styles.systemButton} ${selectedSystem === 'psychosocial' ? styles.active : ''}`}>Psychosocial</div></td>
            </tr>
          </tbody>
        </table>
      </ContentBox>
    );

    return (
      <Form>
        <ContentBox>
          <div className={styles.saHeader}>System Assessments</div>
        </ContentBox>
        {systemSelector}
        <div className={selectedSystem !== 'cardiovascular' ? styles.hidden : ''}>
          <ViewCardiovascular cardiovascular={cardiovascular} />
        </div>
        <div className={selectedSystem !== 'respiratory' ? styles.hidden : ''}>
          <ViewRespiratory respiratory={respiratory} />
        </div>
        <div className={selectedSystem !== 'neurological' ? styles.hidden : ''}>
          <ViewNeurological neurological={neurological} />
        </div>
        <div className={selectedSystem !== 'integumentary' ? styles.hidden : ''}>
          <ViewIntegumentary integumentary={integumentary} />
        </div>
        <div className={selectedSystem !== 'sensory' ? styles.hidden : ''}>
          <ViewSensory sensory={sensory} />
        </div>
        <div className={selectedSystem !== 'musculoskeletal' ? styles.hidden : ''}>
          <ViewMusculoskeletal musculoskeletal={musculoskeletal} />
        </div>
        <div className={selectedSystem !== 'gastrointestinal' ? styles.hidden : ''}>
          <ViewGastrointestinal gastrointestinal={gastrointestinal} />
        </div>
        <div className={selectedSystem !== 'genitourinary' ? styles.hidden : ''}>
          <ViewGenitourinary genitourinary={genitourinary} />
        </div>
        <div className={selectedSystem !== 'pain' ? styles.hidden : ''}>
          <ViewPain pain={pain} />
        </div>
        <div className={selectedSystem !== 'psychosocial' ? styles.hidden : ''}>
          <ViewPsychosocial psychosocial={psychosocial} />
        </div>
        <ContentBox>
          <table>
            <tbody>
              <tr>
                <td><PrimaryText>Exam Date </PrimaryText></td>
                <td><DatetimeText field='date' initialValue={data.date} disabled /></td>
              </tr>
              <tr className={styles.editHistoryRow}>
                <td><strong>View History </strong></td>
                <td>{editHistory || '--'}</td>
              </tr>
            </tbody>
          </table>
          <Button onClick={this.props.closePage}>Close</Button>
        </ContentBox>
      </Form>
    );
  }
}

export default ViewSystemAssessment;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewSystemAssessment.jsx